import { Journey, Travel } from "@gen/travel/v1/common_pb";
import { Modal, Button, Radio, RadioGroup } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { routes } from "@routes";
import { useState } from "react";
import { CompactJourney } from "./CompactJourney";
interface ExchangeModalProps {
  travel?: Travel;
  isOpen: boolean;
  onClose: () => void;
}

export function ExchangeModal({ travel, isOpen, onClose }: ExchangeModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [selectedJourney, setSelectedJourney] = useState<Journey | undefined>(
    travel?.outward,
  );
  const [prevTravel, setPrevTravel] = useState(travel);
  if (travel !== prevTravel) {
    setPrevTravel(travel);
    if (!selectedJourney) {
      setSelectedJourney(travel?.outward);
    }
  }

  async function handleConfirm() {
    if (!travel || !selectedJourney) return;
    navigate(
      routes.EXCHANGE_SEARCH.replace(":travelId", travel.id).replace(
        ":journeyId",
        selectedJourney.id,
      ),
      {
        state: {
          journey: selectedJourney,
        },
      },
    );
  }

  if (!travel || !travel.outward || !travel.inward) return null;

  return (
    <Modal size="auto" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4 max-w-[600px]">
        <h2 className="font-jakarta text-lg font-bold">
          {t("userBookings.exchangeRequest")}
        </h2>
        <div className="w-full">
          <RadioGroup
            align="horizontal"
            gap="4px"
            value={selectedJourney?.id}
            onChange={(e) =>
              setSelectedJourney(
                travel.outward?.id === e.target.value
                  ? travel.outward
                  : travel.inward,
              )
            }
          >
            <Radio value={travel.outward.id}>
              <span className="font-jakarta text-lg">
                {t("userBookings.exchangeOutward")}
              </span>
            </Radio>
            <CompactJourney
              travel={travel}
              journey={travel.outward}
              displayPrice
            />
            <span className="h-4"></span>
            <Radio value={travel.inward.id}>
              <span className="font-jakarta text-lg">
                {t("userBookings.exchangeInward")}
              </span>
            </Radio>
            <CompactJourney
              travel={travel}
              journey={travel.inward}
              displayPrice
            />
          </RadioGroup>
        </div>
        <div className="flex gap-2 justify-end">
          <Button onClick={onClose} kind="outline" size="compact">
            {t("cancel")}
          </Button>
          <Button onClick={handleConfirm} size="compact">
            {t("confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
